
import { defineComponent, PropType, ref, watch } from 'vue';
import RangeInput from '@/components/RangeInput.vue';
import { FormulationAndRouteFull } from '@/service/models/response/drug-model-detail/formulation-and-route-full';
import { DosageRepeatVM } from '@/service/view-models/dosage-choices/dosage-repeat-vm';

export default defineComponent({
    components: {
        RangeInput,
    },

    props: {
        modelValue: {
            type: Object as PropType<DosageRepeatVM>,
            required: true,
        },

        formulationAndRoute: {
            type: Object as PropType<FormulationAndRouteFull>,
            required: true,
        }
    },

    emits: {
        "update:modelValue": (payload: DosageRepeatVM) => typeof payload === "object",
    },

    setup(props, {emit})
    {
        const dosage = ref<DosageRepeatVM>(props.modelValue);

        // Emit the change in model value each time it is modified by the user.
        // This is actually not required because the object reference is shared, but
        // theoretically it should be isolated and the change should be propagated by an event like this.
        watch(
            dosage,
            (newValue) => emit("update:modelValue", newValue),
            { deep: true }
        );

        return { dosage };
    },
})
